export default __webpack_public_path__ + "static/media/whitelist-launch-skeleton.311941cc.png";